// import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";

// import { Link } from "react-router-dom";

function ContextMenu() {
  return (
    <div></div>
  )
  //  return (
  //    <div className="z-50 fixed top-4 right-4">
  //      <div className="dropdown dropdown-left">
  //        <label
  //          tabIndex={0}
  //          className="btn m-1 p-0 px-0 bg-base-100 bg-opacity-5 border-0"
  //        >
  //          <EllipsisVerticalIcon className="h-6 w-6 dark:text-white" />
  //        </label>
  //        <ul
  //          tabIndex={0}
  //          className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52"
  //        >
  //          <li>
  //            <Link to="login">Login</Link>
  //          </li>
  //        </ul>
  //      </div>
  //    </div>
  //  );
}

export {
    ContextMenu   
}